import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-wire-transfer',
  templateUrl: './icon-wire-transfer.component.html'
})
export class IconWireTransferComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
